import { createContext } from 'react';

var ScrollNavContext = createContext(null);
function calculateOffset(_a) {
    var section = _a.section, index = _a.index, allSections = _a.allSections, maxScroll = _a.maxScroll, scrollTop = _a.scrollTop, _b = _a.defaultOffsetTop, defaultOffsetTop = _b === void 0 ? 0 : _b;
    if (index === 0) {
        return {
            id: section.id,
            offset: 0,
        };
    }
    var offsetTop = Math.floor(section.ref.getBoundingClientRect().top + scrollTop) -
        defaultOffsetTop;
    var isReachable = offsetTop <= maxScroll;
    if (isReachable) {
        return {
            id: section.id,
            offset: offsetTop,
        };
    }
    var allSectionsHeight = allSections.reduce(function (height, section) { return height + section.ref.clientHeight; }, 0);
    var prevSectionsRatios = allSections
        .slice(0, index)
        .reduce(function (ratio, section) {
        return ratio + section.ref.clientHeight / allSectionsHeight;
    }, 0);
    var scrollRatio = prevSectionsRatios + section.ref.clientHeight / allSectionsHeight;
    var offset = Math.floor(scrollRatio * maxScroll);
    return {
        id: section.id,
        offset: offset,
    };
}

export { ScrollNavContext, calculateOffset };
